import { db } from '../../firebase/firebaseConfig.js'

export default {
  checkAddressRegistered ({ state }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('feedbackpublic').where('feedbackAddressHandle', '==', payload.val.trim()).get().then((querySnapshot) => {
          if (querySnapshot.empty) {
            resolve({
              res: true,
              context: payload.val
            })
          } else {
            resolve({
              res: false,
              context: payload.val
            })
          }
        })
        .catch(function(e) {
          reject(e)
        })
    })
  }
}
